/**
 * Size Chart Revamp Modal Handler
 * Adheres strictly to Shopify CRO Development Guidelines
 */

(function () {
  'use strict';

  // ── Centralized DOM Elements & State ─────────────────────────────
  function getModalElements() {
    return {
      modal: document.querySelector('[data-sc-modal="container"]') || document.getElementById('cp-sc-revamp-modal') || document.querySelector('.cp-sc-revamp-modal'),
      overlay: document.querySelector('[data-sc-overlay="backdrop"]') || document.getElementById('cp-sc-revamp-overlay') || document.querySelector('.cp-sc-revamp-overlay'),
      closeButtons: document.querySelectorAll('[data-sc-action="close"], #cp-sc-revamp-close, .cp-sc-revamp-close'),
      triggers: document.querySelectorAll('[data-sc-trigger="open"], .cp-size-chart-revamp-trigger, .CP-chip-item.CP-size-chart'),
      tabButtons: document.querySelectorAll('[data-sc-tab], .cp-sc-revamp-tab'),
      tabContents: document.querySelectorAll('[data-sc-tab-content], .cp-sc-revamp-tab-content'),
      unitButtons: document.querySelectorAll('[data-sc-unit], .cp-sc-revamp-unit-btn'),
      tableWrappers: document.querySelectorAll('[data-sc-table-wrapper], .cp-sc-revamp-table-wrapper')
    };
  }

  // ── Restructure Table Titles ─────────────────────────────────────
  function restructureTableTitles() {
    try {
      const { tableWrappers } = getModalElements();
      if (!tableWrappers || tableWrappers.length === 0) {
        return;
      }

      tableWrappers.forEach((wrapper) => {
        if (wrapper.getAttribute('data-sc-restructured') === 'true') {
          return;
        }

        const toMove = [];
        for (let i = 0; i < wrapper.children.length; i++) {
          if (wrapper.children[i].tagName === 'TABLE') {
            break;
          }
          toMove.push(wrapper.children[i]);
        }

        if (toMove.length > 0) {
          const header = document.createElement('div');
          header.className = 'cp-sc-table-header';
          toMove.forEach((el) => header.appendChild(el));
          if (wrapper.parentNode) {
            wrapper.parentNode.insertBefore(header, wrapper);
          }
        }

        wrapper.setAttribute('data-sc-restructured', 'true');
      });
    } catch (error) {
      // Guarded against breaking page
    }
  }

  // ── Scroll Arrows Detection ──────────────────────────────────────
  function updateScrollArrows() {
    try {
      const { tableWrappers } = getModalElements();
      if (!tableWrappers || tableWrappers.length === 0) {
        return;
      }

      tableWrappers.forEach((wrapper) => {
        const parent = wrapper.parentElement;
        const arrow = parent ? parent.querySelector('[data-sc-arrow], .cp-sc-scroll-arrow') : null;
        const hasOverflow = wrapper.scrollWidth > wrapper.clientWidth;

        if (arrow) {
          arrow.style.display = hasOverflow ? 'flex' : 'none';
          arrow.style.animation = hasOverflow ? 'sideBounce 1s infinite alternate' : 'none';
        }
      });
    } catch (error) {
      // Guarded
    }
  }

  // ── Modal Actions ────────────────────────────────────────────────
  function openSizeChartModal() {
    try {
      const { modal, overlay } = getModalElements();
      if (!modal || !overlay) {
        return;
      }

      restructureTableTitles();

      modal.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('cp-sizechart-revamp-modal-open');

      updateScrollArrows();
    } catch (error) {
      // Guarded
    }
  }

  function closeSizeChartModal() {
    try {
      const { modal, overlay, tabButtons, tabContents } = getModalElements();
      if (!modal || !overlay) {
        return;
      }

      modal.classList.remove('active');
      overlay.classList.remove('active');
      document.body.classList.remove('cp-sizechart-revamp-modal-open');

      // Reset to first tab on close
      if (tabButtons && tabButtons.length > 0 && tabContents && tabContents.length > 0) {
        tabButtons.forEach((btn, index) => {
          if (index === 0) {
            btn.classList.add('active');
          } else {
            btn.classList.remove('active');
          }
        });

        tabContents.forEach((content, index) => {
          if (index === 0) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });
      }
    } catch (error) {
      // Guarded
    }
  }

  // ── Tab Handler ──────────────────────────────────────────────────
  function handleTabClick(event) {
    try {
      const clickedTab = event.currentTarget;
      const targetTabId = clickedTab.getAttribute('data-sc-tab') || clickedTab.getAttribute('data-tab');
      if (!targetTabId) {
        return;
      }

      const { tabButtons, tabContents } = getModalElements();

      tabButtons.forEach((btn) => btn.classList.remove('active'));
      tabContents.forEach((content) => content.classList.remove('active'));

      clickedTab.classList.add('active');

      const targetContent = document.querySelector(`[data-sc-tab-content="${targetTabId}"]`) || document.getElementById(`cp-sc-tab-${targetTabId}`);
      if (targetContent) {
        targetContent.classList.add('active');
      }

      updateScrollArrows();
    } catch (error) {
      // Guarded
    }
  }

  // ── Unit Switcher (Inches / CM) ──────────────────────────────────
  function initNumericCellCache() {
    try {
      const { tableWrappers } = getModalElements();
      if (!tableWrappers) return;

      tableWrappers.forEach((wrapper) => {
        const rows = wrapper.querySelectorAll('tr');
        rows.forEach((row) => {
          const cells = row.querySelectorAll('td');
          cells.forEach((cell, cellIndex) => {
            if (cellIndex === 0) {
              return; // Skip label column
            }

            const cellText = cell.textContent.trim();
            const isPurelyNumeric = /^\d+(\.\d+)?(-\d+(\.\d+)?)?$/.test(cellText);

            if (isPurelyNumeric && !cell.hasAttribute('data-sc-inches')) {
              cell.setAttribute('data-sc-inches', cellText);
            }
          });
        });
      });
    } catch (error) {
      // Guarded
    }
  }

  function handleUnitToggle(event) {
    try {
      const clickedBtn = event.currentTarget;
      const selectedUnit = clickedBtn.getAttribute('data-sc-unit') || clickedBtn.getAttribute('data-unit');
      if (!selectedUnit) {
        return;
      }

      const { unitButtons } = getModalElements();
      unitButtons.forEach((btn) => btn.classList.remove('active'));
      clickedBtn.classList.add('active');

      const cells = document.querySelectorAll('td[data-sc-inches]');
      cells.forEach((cell) => {
        const originalInches = cell.getAttribute('data-sc-inches');
        if (!originalInches) {
          return;
        }

        if (selectedUnit === 'cm') {
          const converted = originalInches.replace(/\d+(\.\d+)?/g, (match) => {
            const num = parseFloat(match);
            return isNaN(num) ? match : String(Math.round(num * 2.54));
          });
          cell.textContent = converted;
        } else {
          cell.textContent = originalInches;
        }
      });
    } catch (error) {
      // Guarded
    }
  }

  // ── Event Initialization ─────────────────────────────────────────
  function initSizeChartModal() {
    try {
      restructureTableTitles();
      initNumericCellCache();

      // Delegated click listener for trigger and close buttons
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-sc-trigger="open"], .cp-size-chart-revamp-trigger, .CP-chip-item.CP-size-chart');
        if (trigger) {
          event.preventDefault();
          openSizeChartModal();
          return;
        }

        const closeAction = event.target.closest('[data-sc-action="close"], .cp-sc-revamp-close, #cp-sc-revamp-overlay');
        if (closeAction) {
          event.preventDefault();
          closeSizeChartModal();
          return;
        }
      });

      // Tab switching
      const { tabButtons, unitButtons } = getModalElements();
      if (tabButtons) {
        tabButtons.forEach((btn) => {
          btn.addEventListener('click', handleTabClick);
        });
      }

      // Unit toggle
      if (unitButtons) {
        unitButtons.forEach((btn) => {
          btn.addEventListener('click', handleUnitToggle);
        });
      }

      // ESC key binding
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeSizeChartModal();
        }
      });

      // Resize listener for table scroll arrows
      window.addEventListener('resize', updateScrollArrows);
    } catch (error) {
      // Guarded
    }
  }

  // Safe global bridge for external triggers
  window.cpSizeChartRevampOpen = openSizeChartModal;
  window.cpSizeChartRevampClose = closeSizeChartModal;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChartModal);
  } else {
    initSizeChartModal();
  }
})();
